import { render, staticRenderFns } from "./CreateTaxPage.vue?vue&type=template&id=2363937a&scoped=true&"
import script from "./CreateTaxPage.vue?vue&type=script&lang=js&"
export * from "./CreateTaxPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateTaxPage.vue?vue&type=style&index=0&id=2363937a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2363937a",
  null
  
)

export default component.exports